<!-- eslint-disable indent -->
<template>
  <div class="main" v-cloak>
    <div class="el-breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="custom">
      <span v-if="objItem.phone_tips">{{objItem.phone_tips}}</span>
      <p v-if="objItem.phone">{{objItem.phone}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        objItem: {}
      }
    },
    mounted() {
      this.$http.post('?s=/apiPc.Index/getCustomerPhone', {
          phone: this.$route.query.phone
        })
        .then(response => {
          this.objItem = response.data;
          console.log(this.objItem)
        })
        .catch(error => {});
    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    background: #f5f5f5;
    padding: 0 123px 200px 123px;

  }

  .main .el-breadcrumbs {
    padding-top: 30px;
    padding-bottom: 140px;
  }

  .custom span {
    font-size: 40px;
    line-height: 64px;
    display: block;
    text-align: center;
  }

  .custom p {
    font-size: 40px;
    line-height: 64px;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/restaurant/customer_phone/customer_phone.vue